import React, { ComponentType } from 'react';
import {
  CellProps,
  isIntegerControl,
  JsonFormsCellRendererRegistryEntry,
  RankedTester,
  rankWith,
} from '@jsonforms/core';
import { withJsonFormsCellProps } from '@jsonforms/react';
import PlusMinus from '../../PlusMinus';
import { RENDERER_RANK_PREFERRED_MATCH } from '../constants';

/**
 * Tester to determine if a control can be used with this cell.
 */
const tester: RankedTester = rankWith(RENDERER_RANK_PREFERRED_MATCH, isIntegerControl);

/**
 * Base cell renderer to show an integer input control.
 * @param props Control props to be hydrated.
 */
const IntegerCellRenderer: ComponentType<CellProps> = (props: CellProps) => {
  return (
    <PlusMinus
      testID={`IntegerCell-${props.id}`}
      value={props.data}
      min={props.schema.minimum}
      max={props.schema.maximum}
      onChange={(newValue: number) => props.handleChange(props.path, newValue)}
    />
  );
};

/**
 * Renderer registry entry for input control.
 * Bundles the tester and the wrapped control for use with form.
 */
export const IntegerCell: JsonFormsCellRendererRegistryEntry = {
  tester,
  cell: withJsonFormsCellProps(IntegerCellRenderer),
};
